import React from 'react'

function PricingTable() {
  return (
    <>
        <table className="price-comparison-table mb-3" style={{border:"1px solid #fff",width:"100%"}}>
            <tbody>
                <tr>
                    <th>Network</th>
                    <th>Single Transfer Fee</th>
                    <th>Rate</th>
                </tr>
                <tr>
                    <td>ETH</td>
                    <td>0.00006* ETH <span>
                        </span>
                    </td>
                    <td>15,000 TXs per 1 ETH</td>
                </tr>
                <tr>
                    <td>BNB</td>
                    <td>0.000286 BNB <span>
                        </span>
                    </td>
                    <td>3,500 TXs per 1 BNB</td>
                </tr>
                <tr>
                    <td>Avalanche</td>
                    <td>0.00166* AVAX</td>
                    <td>600 TXs per 1 AVAX</td>
                </tr>
                <tr>
                    <td>Polygon</td>
                    <td>0.1 MATIC <span>
                        </span>
                    </td>
                    <td>10 TXs per 1 MATIC</td>
                </tr>
                <tr>
                    <td>TRX</td>
                    <td>0.004 TRX <span>
                        </span>
                    </td>
                    <td>250 TXs per 1 TRX</td>
                </tr>

            </tbody>
        </table>
</>
  )
}

export default PricingTable